import React from 'react';
import { Container } from '@mui/system';
import { Box, Typography } from '@mui/material';
import FAQItem from '../../components/Collapsible/Collapsible';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { faqs } from './data';
import { strings } from '../../constants';
import { FooterContainer } from '../../components/ScreenContainer/FooterScreenContainer/FooterContainer';

const FAQ = () => {
    const { themeStyle } = useThemeContext();

    return (
        <Container
            disableGutters
            maxWidth={false}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <FooterContainer>
                <Box sx={{ width: '100%', maxWidth: 600 }}>
                    <Typography
                        sx={{
                            mb: 2,
                            fontSize: {
                                sm: 24,
                                xs: 16,
                                lg: 24,
                            },
                        }}
                        style={{
                            fontFamily: FONT_ENUM.REGULAR_HEADER,
                            color: theme[themeStyle].lightWhite,
                            textAlign: 'center',
                        }}>
                        {strings.faq}
                    </Typography>
                    {faqs.map((faq, index) => (
                        <FAQItem key={index} question={faq.question} answer={faq.answer} />
                    ))}
                </Box>
            </FooterContainer>
        </Container>
    );
};

export { FAQ };
